module.exports = __webpack_public_path__ + "static/showcase-tile-01-a5dac5a6d6ae8ede41d30e10e9b123b3.jpg";